module.exports = __webpack_public_path__ + "img/editInsert.930b0302.svg";